import React from 'react';

import FormHeader from 'prequalificationV2/components/FormHeader';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';

const NotAbleToAccept = () => {
  return (
    <FormHeader
      title="Your loan inquiry matches a file that was previously and is currently rejected. If you feel your situation improves you can apply no sooner than 45 days after your initial loan inquiry was rejected."
      percent={ProgressBarStatus.Failed}
    />
  );
};

export default NotAbleToAccept;
